import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { decodeJwt } from 'jose';
import validate from 'uuid-validate';

import Notification from './Notification';
import ChangePassword from './ChangePassword';
import ChangeEmail from './ChangeEmail';
import Languages from './Language';
import TimeFormat from './TimeFormat';
import Permissions from './Permissions';
import Other from './Other';
import { ContentWrapper, Loader, Tabs, TabPanel } from 'components';
import {
  getChangeProfileSettingsLoading,
  getFullAuthUser,
} from 'store/selectors/auth';

import { Header, Content, StyledFloatingLoader } from './styled';

const UserProfileSettingsPage = () => {
  const { t } = useTranslation();
  const user = useSelector(getFullAuthUser);
  const loading = useSelector(getChangeProfileSettingsLoading);
  const decoded = decodeJwt(user?.idToken);
  const canChangeCredentials = decoded && validate(decoded['cognito:username']);

  if (isEmpty(user)) {
    return <Loader />;
  }

  return (
    <ContentWrapper minHeight="auto">
      {loading && (
        <StyledFloatingLoader>
          <Loader size="60px" type={null} />
        </StyledFloatingLoader>
      )}
      <Header>{t('profileSettings.title')}</Header>
      <Content>
        <Tabs variant="navigation" navigationLayout="panel">
          <TabPanel label={t('profileSettings.notification')}>
            <Notification />
          </TabPanel>
          {canChangeCredentials ? (
            <TabPanel label={t('profileSettings.changeEmail')}>
              <ChangeEmail />
            </TabPanel>
          ) : null}
          {canChangeCredentials ? (
            <TabPanel label={t('profileSettings.changePassword')}>
              <ChangePassword />
            </TabPanel>
          ) : null}
          <TabPanel label={t('profileSettings.language')}>
            <Languages />
          </TabPanel>
          <TabPanel label={t('profileSettings.timeFormat')}>
            <TimeFormat />
          </TabPanel>
          <TabPanel label={t('profileSettings.permissions')}>
            <Permissions />
          </TabPanel>
          <TabPanel label={t('profileSettings.other')}>
            <Other />
          </TabPanel>
        </Tabs>
      </Content>
    </ContentWrapper>
  );
};

export default UserProfileSettingsPage;
